import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export default function Toolbar({
  report,
  onNew,
  onSave,
  onLoad,
  onExport,
  onPreview,
  previewMode,
  onNameChange
}) {
  const [isEditingName, setIsEditingName] = useState(false);
  const [tempName, setTempName] = useState(report.name);

  const handleNameSave = () => {
    if (tempName.trim()) {
      onNameChange(tempName.trim());
    }
    setIsEditingName(false);
  };

  // Inline styles to ensure visibility
  const toolbarStyle = {
    display: 'flex',
    alignItems: 'center',
    padding: '10px 16px',
    background: '#fff',
    borderBottom: '2px solid #dee2e6',
    gap: '10px',
    flexShrink: 0,
    flexWrap: 'wrap',
    minHeight: '56px'
  };

  const btnStyle = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '6px',
    padding: '8px 14px',
    border: '1px solid #dee2e6',
    background: '#fff',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '13px',
    color: '#495057',
    fontWeight: 500,
    transition: 'all 0.15s'
  };

  const btnPrimaryStyle = {
    ...btnStyle,
    background: '#007bff',
    borderColor: '#007bff',
    color: '#fff'
  };

  const btnSuccessStyle = {
    ...btnStyle,
    background: '#28a745',
    borderColor: '#28a745',
    color: '#fff'
  };

  const btnWarningStyle = {
    ...btnStyle,
    background: '#ffc107',
    borderColor: '#ffc107',
    color: '#212529'
  };

  const separatorStyle = {
    width: '1px',
    height: '28px',
    background: '#dee2e6',
    margin: '0 4px'
  };

  return (
    <div style={toolbarStyle}>
      {/* Logo */}
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontWeight: 'bold', color: '#007bff', fontSize: '16px' }}>
        <FontAwesomeIcon icon="file-alt" />
        <span>CrystalCKD</span>
      </div>

      <div style={separatorStyle}></div>

      {/* Report Name */}
      {isEditingName ? (
        <input
          type="text"
          value={tempName}
          onChange={e => setTempName(e.target.value)}
          onBlur={handleNameSave}
          onKeyDown={e => { if (e.key === 'Enter') handleNameSave(); if (e.key === 'Escape') setIsEditingName(false); }}
          autoFocus
          style={{ padding: '6px 12px', border: '2px solid #007bff', borderRadius: '4px', fontSize: '14px', width: '200px', outline: 'none' }}
        />
      ) : (
        <span
          onClick={() => { setTempName(report.name); setIsEditingName(true); }}
          style={{ cursor: 'pointer', padding: '6px 12px', borderRadius: '4px', background: '#f8f9fa', border: '1px solid #dee2e6', fontSize: '14px' }}
          title="Click to edit name"
        >
          {report.name || 'Untitled Report'} <FontAwesomeIcon icon="pencil-alt" style={{ fontSize: '10px', color: '#6c757d', marginLeft: '6px' }} />
        </span>
      )}

      <div style={separatorStyle}></div>

      {/* File Actions */}
      <button style={btnStyle} onClick={onNew} title="Nuovo report">
        <FontAwesomeIcon icon="file" /> Nuovo
      </button>
      <button style={btnStyle} onClick={onLoad} title="Apri file .crystal.json">
        <FontAwesomeIcon icon="folder-open" /> Apri
      </button>
      <button style={btnStyle} onClick={onSave} title="Salva come file .crystal.json">
        <FontAwesomeIcon icon="save" /> Salva
      </button>

      <div style={separatorStyle}></div>

      {/* Preview Toggle */}
      <button
        style={previewMode ? btnWarningStyle : btnPrimaryStyle}
        onClick={onPreview}
        title={previewMode ? 'Exit Preview and return to Edit' : 'Preview with Data'}
      >
        <FontAwesomeIcon icon={previewMode ? 'edit' : 'eye'} />
        {previewMode ? 'Torna a Edit' : 'Anteprima'}
      </button>

      {/* Export */}
      <button style={btnSuccessStyle} onClick={onExport} title="Export to PDF">
        <FontAwesomeIcon icon="file-pdf" /> Esporta PDF
      </button>

      {/* Spacer */}
      <div style={{ flex: 1 }}></div>

      {/* Preview Mode Indicator */}
      {previewMode && (
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: '8px',
          padding: '8px 14px',
          background: '#fff3cd',
          color: '#856404',
          borderRadius: '4px',
          fontSize: '13px',
          fontWeight: 600,
          border: '1px solid #ffc107'
        }}>
          <FontAwesomeIcon icon="exclamation-triangle" />
          MODALITA' ANTEPRIMA - Clicca "Torna a Edit" per modificare
        </div>
      )}
    </div>
  );
}
